import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ScoreModal = ({ show, handleClose, handleChange, handleSave, formData, modalType }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{modalType === "edit" ? "Update Score" : "Add New Score"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Date</Form.Label>
            <Form.Control type="date" name="assdate" value={formData.assdate} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Test</Form.Label>
            <Form.Control type="text" name="coursetest" value={formData.coursetest} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Score</Form.Label>
            <Form.Control type="number" step="1" name="score" value={formData.score} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Goal</Form.Label>
            <Form.Control type="number" step="1" name="goal" value={formData.goal} onChange={handleChange} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button variant="primary" onClick={handleSave}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScoreModal;
